import { Input, Tooltip } from '@mairistem/composants';
import type { Error } from '@mairistem/comptabilite';
import type React from 'react';

interface TooltipInputProps {
	id: string;
	name: string;
	label: string;
	value: number | string;
	flowing: boolean;
	placeholder: string;
	description: string;
	error: Error;
	required: boolean;
	action: React.ReactNode;
	onChange: (
		event: React.SyntheticEvent,
		data: { name: string; value: unknown },
	) => void;
	onBlur: (event: React.FocusEvent) => void;
	position: string;
	maxLength?: number;
}

const TooltipInput = ({
	id,
	name,
	label,
	value = '',
	flowing = false,
	description,
	error,
	onChange,
	onBlur,
	required = false,
	placeholder,
	action,
	position,
	maxLength,
	...rest
}: TooltipInputProps) => (
	<Tooltip
		trigger={
			<Input
				id={id}
				key={name}
				name={name}
				label={label}
				placeholder={placeholder}
				value={value}
				onChange={onChange}
				onBlur={onBlur}
				required={required}
				action={action}
				maxLength={maxLength}
				{...rest}
			/>
		}
		position={position}
		flowing={flowing}
		description={description}
		{...(error && {
			message: error.message,
			type: 'error',
		})}
	/>
);

export default TooltipInput;
